<script>
    export default {
        name: "ApplicationFunctionsCard",
        props: {
            func: Object,
        },
    };
</script>

<template>
    <div class="application-functions-card">
        <div class="application-functions-card__image">
            <img :src="`/static/picooc/application/functions/${func.subtitle}.svg`" alt="" />
        </div>
        <div class="application-functions-card__title">{{ func.title }}</div>
        <div class="application-functions-card__text" v-html="func.text"></div>
    </div>
</template>

<style lang="scss">
    .application-functions-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding: 12px 24px 32px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        box-shadow: 0 0 20px rgba(63, 158, 211, 0.15);
        @include bp($bp-desktop-sm) {
            justify-content: flex-start;
            padding: 12px 32px 40px;
            box-shadow: none;
            transition: box-shadow 0.2s ease-in;
            &:hover {
                .application-functions-card__image {
                    transform: translateY(-2px);
                }
            }
        }
    }

    .application-functions-card__image {
        width: 80px;
        height: 80px;
        margin: 0 auto 4px;
        @include bp($bp-desktop-sm) {
            width: 94px;
            height: 94px;
            margin-bottom: 12px;
            transition: transform 0.2s ease-in;
        }
    }

    .application-functions-card__title {
        margin-bottom: 12px;
        color: #353535;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        @include bp($bp-desktop-sm) {
            min-height: 50px;
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
        }
    }

    .application-functions-card__text {
        color: #353535;
        font-size: 14px;
        line-height: 28px;

        @include bp($bp-desktop-sm) {
            color: #474747;
            font-size: 16px;
            line-height: 32px;
        }
    }
</style>
